import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { TipoDocumental } from '../models/tipo-documental.model';
import { TipoDocumentalListParams } from '../models/tipo-documental-list-params.model';
import { PaginatedResponse } from '../../../core/shared/models/pagination.model';

export const TIPO_DOCUMENTAL_REPOSITORY = new InjectionToken<TipoDocumentalRepository>('TipoDocumentalRepository');

export interface TipoDocumentalRepository {
  listarTiposDocumentais(params: TipoDocumentalListParams): Observable<PaginatedResponse<TipoDocumental>>;
  buscarTipoDocumentalPorId(id: number): Observable<TipoDocumental>;
  criarTipoDocumental(payload: TipoDocumental): Observable<TipoDocumental>;
  editarTipoDocumental(id: number, payload: TipoDocumental): Observable<TipoDocumental>;
  excluirTipoDocumental(id: number): Observable<void>;
}


